module.exports = __webpack_public_path__ + "img/facebook.5c15afeb.svg";